import {gql} from '@apollo/client';

const GET_COUNTRY_CURRENCIES = gql`
  query GetCountries {
    countries {
      id
      name
      businessRegion
      currency
      repairCostDimension
      maintenanceCostDimension
      vehicleRegistrationCostAllowed
      countryCodes
    }
  }
`;

export default GET_COUNTRY_CURRENCIES;
